/**
 * PaymentExpiredPage - Standalone page for expired payment sessions
 *
 * This page is shown when a user navigates to /pay/expired
 * Used as a fallback redirect target when sessions expire.
 *
 * Note: In most cases, the PaymentPage itself handles expiry display.
 * This page exists for direct navigation or as a fallback.
 */

import React from 'react';
import './PaymentPage.css';

const PaymentExpiredPage = () => {
  return (
    <div className="payment-page">
      <div className="payment-container">
        {/* Header with logo */}
        <div className="payment-header">
          <div className="payment-logo">KuberCrypto</div>
        </div>

        {/* Error content */}
        <div className="payment-error">
          {/* Clock icon for expired */}
          <svg className="error-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12,6 12,12 16,14"/>
          </svg>

          <h2 className="error-title">Session Expired</h2>

          <p className="error-message">
            This payment session has expired.
          </p>

          <p className="error-hint">
            Please contact the merchant to request a new payment link.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentExpiredPage;
